import React from "react";
import useScrollToTop from "./../../../hooks/useScollToTop";

import useNewsAdmin from "./hooks/useNewsAdmin";

import NewsHero from "./components/NewsHero";
import NewsStatsGrid from "./components/NewsStatsGrid";
import NewsFiltersPanel from "./components/NewsFiltersPanel";
import NewsList from "./components/NewsList";
import NewsFormDrawer from "./components/NewsFormDrawer";
import NewsPreviewDrawer from "./components/NewsPreviewDrawer";
import NewsDeleteDrawer from "./components/NewsDeleteDrawer";
import MediaPickerDrawer from "./components/MediaPickerDrawer";

export default function NewsAdmin() {
  useScrollToTop();
  const news = useNewsAdmin();

  return (
    <div className="mx-auto w-full max-w-[1600px] px-1 pb-10 sm:px-2 lg:px-0">
      <NewsHero
        stats={news.stats}
        loading={news.loading}
        onCreate={news.openCreate}
      />

      {news.notice ? (
        <div className="mt-5 rounded-[1.5rem] border border-emerald-200 bg-emerald-50 px-5 py-4 text-sm font-bold text-emerald-800 shadow-sm dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
          {news.notice}
        </div>
      ) : null}

      {news.error ? (
        <div className="mt-5 rounded-[1.5rem] border border-rose-200 bg-rose-50 px-5 py-4 text-sm font-bold text-rose-800 shadow-sm dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300">
          {news.error}
        </div>
      ) : null}

      <NewsStatsGrid stats={news.stats} loading={news.loading} />

      <NewsFiltersPanel
        q={news.q}
        activeFilter={news.activeFilter}
        limit={news.limit}
        onChangeQ={news.setQ}
        onChangeActiveFilter={news.changeActiveFilter}
        onChangeLimit={news.changeLimit}
        onSubmit={news.onSubmitSearch}
        onReset={news.resetFilters}
        onRefresh={news.fetchData}
        loading={news.loading}
      />

      <NewsList
        items={news.items}
        loading={news.loading}
        total={news.total}
        page={news.page}
        totalPages={news.totalPages}
        actionId={news.actionId}
        onPageChange={news.setPage}
        onPreview={news.openPreview}
        onEdit={news.openEdit}
        onToggle={news.onToggle}
        onAskDelete={news.openDelete}
      />

      <NewsFormDrawer
        open={news.formOpen}
        form={news.form}
        fieldErrors={news.fieldErrors}
        saving={news.saving}
        isEdit={!!news.currentId}
        onClose={news.closeForm}
        onChange={news.updateFormField}
        onSave={news.onSave}
        onOpenMediaPicker={news.openMediaPicker}
      />

      <NewsPreviewDrawer
        open={!!news.previewItem}
        item={news.previewItem}
        onClose={news.closePreview}
        onEditFromPreview={news.openEditFromPreview}
      />

      <NewsDeleteDrawer
        open={!!news.deleteItem}
        item={news.deleteItem}
        deleting={news.deleting}
        onClose={news.closeDelete}
        onConfirm={news.onDelete}
      />

      <MediaPickerDrawer
        open={news.mediaPickerOpen}
        onClose={news.closeMediaPicker}
        onSelect={news.handleSelectMedia}
      />
    </div>
  );
}